/* eslint-disable no-nested-ternary */
/* eslint-disable react/jsx-no-useless-fragment */
/* eslint-disable import/no-cycle */
import {
  Card, Col,
  Row,
  Select,
  Space,
  Typography
} from 'antd';
import TextArea from 'antd/es/input/TextArea';
import dayjs from 'dayjs';
import React, { useEffect } from 'react';
import { Controller, UseFormReturn } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { useQuery } from 'react-query';

import { KTApproveParamsForm } from '../ApproveDetail';

import { useAppSelector } from 'app/store';
import { DropdownBankElement } from 'common/components/DropdownBankType';
import { DropdownElement } from 'common/components/DropdownType';
import Input from 'common/components/Input';
import { Picker } from 'common/components/Picker';
import { getBankDefaultService } from 'common/services/extends/banks';
import roles, { getPermission } from 'configs/roles';

interface TimekeepingProps {
  onlyViewData?: boolean;
  methodAccount: UseFormReturn<KTApproveParamsForm>;
  disabled?: boolean;
  viewOnly?: boolean;
}

const SalaryTableInfo: React.FC<TimekeepingProps> = ({
  onlyViewData, methodAccount, disabled, viewOnly
}) => {
  const {
    roles: rolesUser
  } = useAppSelector((state) => state.auth);
  /* Hooks */
  const { t } = useTranslation();
  const [isEdit, setIsEdit] = React.useState<boolean>(false);

  const { data: bankDefault, isLoading } = useQuery(
    ['getBankDefaultService'],
    () => getBankDefaultService(),
    {
      enabled: getPermission(rolesUser, roles.BANK_INDEX)
    }
  );

  const methodTransferOptions: OptionType[] = [
    {
      label: t('approveSalary.cash'),
      value: 1
    },
    {
      label: t('approveSalary.tranfer'),
      value: 2
    },
  ];

  useEffect(() => {
    const bankData = methodAccount.getValues('bankId');
    if (bankDefault?.bankData && !bankData) {
      methodAccount.setValue('bankId', {
        label: bankDefault.bankData.name,
        value: bankDefault.bankData.id
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [bankDefault, methodAccount, methodAccount.getValues('bankId')]);

  /* Render */
  return (
    <Row gutter={16}>
      <Col>
        <Card
          title={(
            <Typography.Title level={4}>
              {t('approveSalary.salaryTableInfo')}
            </Typography.Title>
          )}
        >
          <div className="site-card-border-less-wrapper">
            <Space
              direction="vertical"
              size={12}
              style={{ width: '100%' }}
            >
              <Row gutter={16}>
                {onlyViewData ? (
                  <Col span={6} className="u-mb-8" style={{ display: 'flex', flexDirection: 'column' }}>
                    <Typography.Text>
                      {t('approveSalary.detailCode')}
                      {' '}
                    </Typography.Text>
                    <div className="u-mt-8">
                      <Typography.Text strong>
                        {
                          methodAccount.getValues('codeDetail') || ''
                        }
                      </Typography.Text>
                    </div>
                  </Col>
                ) : (
                  <Col span={6} className="u-mb-8">
                    <Typography.Text strong>
                      {t('approveSalary.detailCode')}
                      {' '}
                    </Typography.Text>
                    <Typography.Text strong type="danger">
                      *
                    </Typography.Text>
                    <Controller
                      name="codeDetail"
                      control={methodAccount.control}
                      render={({ field: { value, onChange }, fieldState: { error } }) => (
                        <Input
                          className="u-mt-8"
                          value={value}
                          onChange={onChange}
                          error={error?.message}
                          placeholder={t('approveSalary.detailCode')}
                          size="large"
                          disabled={viewOnly}
                        />
                      )}
                    />
                  </Col>
                )}
                {onlyViewData ? (
                  methodAccount.getValues('dateTransfer') ? (
                    <Col span={6} className="u-mb-8" style={{ display: 'flex', flexDirection: 'column' }}>
                      <Typography.Text>
                        {t('approveSalary.approveDate')}
                        {' '}
                      </Typography.Text>
                      <div className="u-mt-8">
                        <Typography.Text strong>
                          {
                            dayjs(methodAccount.getValues('dateTransfer')).format('DD/MM/YYYY')
                          }
                        </Typography.Text>
                      </div>
                    </Col>
                  ) : ''
                ) : (
                  <Col span={6} className="u-mb-8">
                    <Typography.Text strong>
                      {t('approveSalary.approveDate')}
                      {' '}
                    </Typography.Text>
                    <Controller
                      name="dateTransfer"
                      control={methodAccount.control}
                      render={({ field, fieldState: { error } }) => (
                        <Picker
                          className="u-mt-8"
                          size="large"
                          value={field.value ? dayjs(field.value) : undefined}
                          onChange={field.onChange}
                          format="DD/MM/YYYY"
                          style={{ width: '100%' }}
                          error={error?.message}
                          disabled={viewOnly}
                        />
                      )}
                    />
                  </Col>
                )}
                {onlyViewData ? (
                  <Col span={6} className="u-mb-8" style={{ display: 'flex', flexDirection: 'column' }}>
                    <Typography.Text>
                      {t('approveSalary.salaryPaymentMethod')}
                      {' '}
                    </Typography.Text>
                    <div className="u-mt-8">
                      <Typography.Text strong>
                        {
                          methodAccount.getValues('methodTransfer')?.label || ''
                        }
                      </Typography.Text>
                    </div>
                  </Col>
                ) : (
                  <Col span={6} className="u-mb-8">
                    <Typography.Text strong>
                      {t('approveSalary.salaryPaymentMethod')}
                      {' '}
                    </Typography.Text>
                    <Typography.Text strong type="danger">
                      *
                    </Typography.Text>
                    <Controller
                      name="methodTransfer"
                      control={methodAccount.control}
                      render={({ field, fieldState: { error } }) => (
                        <DropdownElement
                          options={methodTransferOptions}
                          locale="vi"
                          placeholder={t('employee.contractType')}
                          isGetOption
                          value={field.value}
                          isShowSearch
                          error={error?.message}
                          onChange={field.onChange}
                          size="large"
                          disabled={disabled || viewOnly}
                        />
                      )}
                    />
                  </Col>
                )}
                {onlyViewData ? (
                  <Col span={6} className="u-mb-8" style={{ display: 'flex', flexDirection: 'column' }}>
                    <Typography.Text>
                      {t('approveSalary.salaryPaymentBank')}
                      {' '}
                    </Typography.Text>
                    <div className="u-mt-8">
                      <Typography.Text strong>
                        {
                          methodAccount.getValues('bankId')?.label || ''
                        }
                      </Typography.Text>
                    </div>
                  </Col>
                ) : (
                  <Col span={6} className="u-mb-8">
                    <Typography.Text strong>
                      {t('approveSalary.salaryPaymentBank')}
                      {' '}
                    </Typography.Text>
                    <Typography.Text strong type="danger">
                      *
                    </Typography.Text>
                    <Controller
                      name="bankId"
                      control={methodAccount.control}
                      render={({ field: { value, onChange }, fieldState: { error } }) => (
                        <>
                          {
                            isEdit ? (
                              <DropdownBankElement
                                placeholder={t('approveSalary.salaryPaymentBank')}
                                isGetOption
                                value={value}
                                isShowSearch
                                error={error?.message}
                                onChange={onChange}
                                size="large"
                                disabled={disabled || viewOnly}
                              />
                            ) : (
                              <Select
                                size="large"
                                disabled={isLoading || disabled || viewOnly}
                                value={value}
                                onClick={() => {
                                  setIsEdit(true);
                                }}
                                style={{ display: 'block', marginTop: 8 }}
                              />
                            )
                          }
                        </>
                      )}
                    />
                  </Col>
                )}
                {onlyViewData ? (
                  methodAccount.getValues('description') ? (
                    <Col span={24} className="u-mt-8">
                      <Typography.Text>
                        {t('salary.describe')}
                        {' '}
                      </Typography.Text>
                      <div className="u-mt-8">
                        <Typography.Text strong>
                          {
                            methodAccount.getValues('description')
                          }
                        </Typography.Text>
                      </div>
                    </Col>
                  ) : ''
                ) : (
                  <Col span={24} className="u-mt-8">
                    <Typography.Text strong>
                      {t('salary.describe')}
                      {' '}
                    </Typography.Text>
                    <Controller
                      name="description"
                      control={methodAccount.control}
                      render={({ field: { value, onChange }, fieldState: { error } }) => (
                        <>
                          <TextArea
                            className="u-mt-8"
                            value={value}
                            onChange={onChange}
                            size="large"
                            rows={4}
                            style={{ minHeight: 50 }}
                            disabled={viewOnly}
                          />
                          {error && (
                            <span
                              className="a-input_errorMessage"
                            >
                              {error.message}
                            </span>
                          )}
                        </>
                      )}
                    />
                  </Col>
                )}
              </Row>
            </Space>
          </div>
        </Card>
      </Col>
    </Row>
  );
};

export default SalaryTableInfo;
